import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { GlobalVariable } from 'app/app.global';
import { DataPackGroup } from '../../app/models/dataPackGroup.model';
import { CommonService } from './common.service';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';

/**
 * $Id: calendar.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */
@Injectable()
export class CalendarService extends CommonService {

  private localURL: string;
  private CALENDAR_PATH: string = '/datapackcalendar';
  

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.CALENDAR_PATH;
  }

  public loadView(pageNumber: number, fetchSize: number) {
    let url = this.localURL + '?action=loadView';
    if(pageNumber >= 0) {
      url += '&pageNumber=' + pageNumber;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listGroups(pageNumber: number, fetchSize: number) {
    let url = this.localURL + '?action=listGroups';
    if(pageNumber >= 0) {
      url += '&pageNumber=' + pageNumber;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listLines(group: DataPackGroup, pageNumber: number, fetchSize: number) {
    let url = this.localURL + '?action=listLines'
    if(group) {
      url += '&groupId=' + group.id;
    }
    if(pageNumber >= 0) {
      url += '&pageNumber=' + pageNumber;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse( this.httpGet(url));
  }

  public saveCalendar(payload: any) {
    payload.action = !payload.calendar.id ? 'createCalendar' : 'updateCalendar';
    return this.convertResponse(this.httpPost(this.localURL, payload));
  }

  public removeCalendar(payload: any) {
    payload.action = 'removeCalendar';
    return this.convertResponse(this.httpPost(this.localURL, payload));
  }

  public setCalendar(payload: any) {
    payload.action = 'setCalendar';
    return this.convertResponse(this.httpPost(this.localURL, payload));
  }

  public unsetCalendar(payload: any) {
    payload.action = 'unsetCalendar';
    return this.convertResponse(this.httpPost(this.localURL, payload));
  }

  public listSpecialDays() {
    let url = this.localURL + '?action=listSpecialDays'; 
    return this.convertResponse(this.httpGet(url));
  }

  public configSpecialDay(days : any, conf : any) {
    let payload : any = {
      action: 'configSpecialDays', 
      specialDaysList : days,
      dataPackSpecialDaysConf: conf
    };
    let url = this.localURL + '?action=configSpecialDays'; 
    return this.convertResponse(this.httpPost(url, payload));  
  }

}


// WEBPACK FOOTER //
// ./src/app/services/calendar.service.ts